import { CSSProperties } from 'react'

const styles: { icon: CSSProperties } = {
  icon: { flexShrink: 0 },
}

export default styles
